const C = {
  name: "CalendarEmpty",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg>
    <path d="M2 9.00293V4.00293H10V5.00293C10 5.55293 10.45 6.00293 11 6.00293C11.55 6.00293 12 5.55293 12 5.00293V4.00293H28V5.00293C28 5.55293 28.45 6.00293 29 6.00293C29.55 6.00293 30 5.55293 30 5.00293V4.00293H37C37.55 4.00293 38 4.45293 38 5.00293V10.0029H3C2.45 10.0029 2 9.55293 2 9.00293ZM38 38.0029H3C2.45 38.0029 2 37.5529 2 37.0029V12.0029H37C37.55 12.0029 38 12.4529 38 13.0029V38.0029ZM38 2.00293H30V1.00293C30 0.45293 29.55 0.00292969 29 0.00292969C28.45 0.00292969 28 0.45293 28 1.00293V2.00293H12V1.00293C12 0.45293 11.55 0.00292969 11 0.00292969C10.45 0.00292969 10 0.45293 10 1.00293V2.00293H2C0.9 2.00293 0 2.90293 0 4.00293V10.0029V12.0029V38.0029C0 39.1029 0.9 40.0029 2 40.0029H38C39.1 40.0029 40 39.1029 40 38.0029V12.0029V10.0029V4.00293C40 2.90293 39.1 2.00293 38 2.00293Z" fill="currentColor"/>
    </svg>

  `
};
export {
  C as CalendarEmpty
};
